import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance from './axiosInstance';

export const defaultBranding = {
  name: 'CORPS DES CLUTCHERS', description: 'ARMA REFORGER · ADMINISTRATION',
  site_title: 'Corps des Clutchers | Administration', logo: '', favicon: '',
};
const BrandingContext = createContext({ branding: defaultBranding });
export const useBranding = () => useContext(BrandingContext);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(defaultBranding);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    axiosInstance.get('/api/branding').then(({ data }) => {
      if (active && typeof data === 'object' && typeof data.name === 'string') setBranding({ ...defaultBranding, ...data });
      else if (active) setError('Branding settings could not be loaded. Reload before editing.');
    }).catch(() => { if (active) setError('Branding settings could not be loaded. Reload before editing.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  useEffect(() => {
    document.title = branding.site_title;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.content = branding.description;
    let icon = document.querySelector('link[rel="icon"]');
    if (!icon) { icon = document.createElement('link'); icon.rel = 'icon'; document.head.appendChild(icon); }
    icon.href = branding.favicon || `${process.env.PUBLIC_URL || ''}/brand-mark.svg`;
  }, [branding]);
  return <BrandingContext.Provider value={{ branding, setBranding, loading, error }}>{children}</BrandingContext.Provider>;
}
